export default "__VITE_ASSET__xTHzaw6R__"